import { jsx as l } from "../../../../../external/preact/jsx-runtime/dist/jsxRuntime.module.js";
import A from "classnames";
import { useMemo as C } from "../../../../../external/preact/hooks/dist/hooks.module.js";
import { AccountDetail as F } from "./AccountDetail.js";
import { Fragment as _ } from "../../../../../external/preact/dist/preact.module.js";
import { getAccountFieldTranslationKey as y, getAccountFieldFormattedValue as S, getAccountFieldTextToCopy as b } from "./utils.js";
/* empty css                    */
const o = "adyen-pe-capital-account-details", n = {
  detail: `${o}__detail`,
  detailContent: `${o}__detail-content`,
  detailLabel: `${o}__detail-label`
}, $ = ({ bankAccount: a, className: i }) => {
  const s = C(() => {
    const { accountNumber: t, iban: e, order: r, region: d, ...m } = a, c = Object.keys({ iban: e, accountNumber: t, ...m, region: d }), u = Array.isArray(r) ? r.filter((p) => c.includes(p)) : c;
    return [...new Set(u)];
  }, [a]);
  return /* @__PURE__ */ l("dl", { className: A(o, i), children: s.map((t) => {
    const e = a[t];
    return e ? /* @__PURE__ */ l(_, { children: /* @__PURE__ */ l(
      F,
      {
        className: n.detail,
        contentClassName: n.detailContent,
        labelClassName: n.detailLabel,
        label: y(t),
        content: S(t, e),
        textToCopy: b(t, e)
      }
    ) }, t) : null;
  }) });
};
export {
  $ as AccountDetails
};
